export default __webpack_public_path__ + "static/media/art-pro-blk-poster-1.fb99af31.jpg";